import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useDispatch} from "react-redux";
import Loader from "../common/Loader";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Footer from "../common/Footer";
import PersonalInfoForm from './personalInfoForm';
import {profileSelector} from "./endpoints/selector";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import { getEmployerUserDetail } from "./endpoints/action";

export default () => {
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const {userDetailList} = useSelector(profileSelector);
    const [userDetailsList, setUserDetailsList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if(config.baseUrl) {
            dispatch(getEmployerUserDetail(config.baseUrl, login.employerUserId));
        }
    }, [config]);

    useEffect(() => {
        if(userDetailList) {
            setUserDetailsList(userDetailList);
        }
    }, [userDetailList]); 

    return(
        <div className="page main-margin">
            <Loader/>
            <Header/>
            <Sidebar/>
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">
                                <h1 className="page-title">Profile</h1>
                            </div>
                            <div className="row">
                                <div class="col-xl-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="panel panel-primary">
                                                <PersonalInfoForm userDetailsList={userDetailsList} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}